import clsx from 'clsx';
import React, { PropsWithChildren, ReactElement } from 'react';
import { Info } from './Info';

export const TextAndIcon = (
  props: PropsWithChildren<{
    text?: string;
    icon?: ReactElement;
    textDataTest?: string;
    small?: boolean;
    iconPosition?: 'left' | 'right';
    textAlign?: 'left' | 'center';
    textClassName?: string;
    info?: string;
  }>
) => {
  const {
    text,
    icon,
    textDataTest,
    small,
    iconPosition,
    textAlign,
    textClassName,
    children,
    info,
  } = props;

  return (
    <div
      className="div-button__container"
      style={{
        flexDirection: iconPosition === 'right' ? 'row-reverse' : 'row',
      }}
    >
      <>
        {!!icon && (
          <div
            className={clsx('div-button__icon', {
              'div-button__icon--alone': !text,
              'div-button__icon--small': small,
            })}
          >
            {icon}
          </div>
        )}
        {!!text ? (
          <span
            className={clsx('div-button__title', textClassName, 'flex-grow-1')}
            style={{ textAlign }}
            data-test={textDataTest ?? ''}
          >
            {text}
          </span>
        ) : (
          <>{children}</>
        )}
        {info && <Info tooltipText={info} tooltipWidth={166} />}
      </>
    </div>
  );
};
